import { render, staticRenderFns } from "./MixedInvestmentPage.vue?vue&type=template&id=d6fa881c"
import script from "./MixedInvestmentPage.vue?vue&type=script&lang=ts"
export * from "./MixedInvestmentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports